import { appCode } from 'config';
import { ROUTES } from '@/const/routes';
import { CONVERSATION_ASSIST_ROUTES } from '@conversationAssist/const/conversationAssist';
import hasConversationAssistPermission from '@/common/permission';

const ConversationAssist = r => require.ensure([], () => r(require('@/components/conversation-assist/ConversationAssist')), 'ConversationAssist');
const ConversationAssistHome = r => require.ensure([], () => r(require('@/components/conversation-assist/Home/Home')), 'Home');
const ConversationAssistWelcome = r => require.ensure([], () => r(require('@/components/conversation-assist/Welcome/Welcome')), 'Welcome');
const ConversationAssistSettings = r => require.ensure([], () => r(require('@/components/conversation-assist/Settings/Settings')), 'Settings');
const ConversationAssistRecommendationSources = r => require.ensure(
  [], () => r(require('@/components/conversation-assist/RecommendationSources/RecommendationSources')), 'RecommendationSources');
const ConversationAssistKnowledgeBases = r => require.ensure(
  [], () => r(require('@/components/conversation-assist/RecommendationSources/components/KnowledgeBases')), 'KnowledgeBases');
const ConversationAssistBots = r => require.ensure(
  [], () => r(require('@/components/conversation-assist/RecommendationSources/components/Bots')), 'Bots');
const ConversationAssistReports = r => require
  .ensure([], () => r(require('@/components/conversation-assist/Reports/Reports')), 'Reports');

const meta = {
  translationKey: 'LEUIComponents.reporting.context.automation',
  translationSubKey: 'LEUIComponents.reporting.context.automation.conversationassist',
};

export default {
  path: `/${appCode}/${ROUTES.CONVERSATION_ASSIST}`,
  name: ROUTES.CONVERSATION_ASSIST,
  components: { [appCode]: ConversationAssist },
  meta,
  beforeEnter: (to, from, next) => {
    if (hasConversationAssistPermission()) {
      if (!from.name && !to.params.routeTo) {
        next({ name: ROUTES.CONVERSATION_ASSIST, params: { routeTo: to.name } });
      } else {
        next();
      }
    } else {
      next({ name: ROUTES.LANDING });
    }
  },
  children: [
    {
      name: CONVERSATION_ASSIST_ROUTES.HOME,
      path: 'home',
      component: ConversationAssistHome,
      meta,
    },
    {
      name: CONVERSATION_ASSIST_ROUTES.WELCOME,
      path: 'welcome',
      component: ConversationAssistWelcome,
      meta,
    },
    {
      name: CONVERSATION_ASSIST_ROUTES.SETTINGS,
      path: 'settings',
      component: ConversationAssistSettings,
      meta,
    },
    {
      name: CONVERSATION_ASSIST_ROUTES.RECOMMENDATION_SOURCES,
      path: 'recommendation',
      component: ConversationAssistRecommendationSources,
      redirect: { name: CONVERSATION_ASSIST_ROUTES.KNOWLEDGE_BASES },
      meta,
      children: [
        {
          name: CONVERSATION_ASSIST_ROUTES.KNOWLEDGE_BASES,
          path: 'kb',
          component: ConversationAssistKnowledgeBases,
          meta,
        },
        {
          name: CONVERSATION_ASSIST_ROUTES.BOTS,
          path: 'bots',
          component: ConversationAssistBots,
          meta,
        },
      ],
    },
    {
      name: CONVERSATION_ASSIST_ROUTES.DETAILED_REPORTS,
      path: 'reports',
      component: ConversationAssistReports,
      meta,
    },
    {
      path: '*', redirect: { name: ROUTES.CONVERSATION_ASSIST },
    },
  ],
};
